export enum FORM_FIELD {
  RATE_SOURCE = 'rateSource',
  PACKAGE_ID = 'packageId',
  BUYING_METRIC = 'buyingMetric',
  SELL_RATE = 'sellRate',
  BUDGET = 'budget',
  FEE_PERCENT = 'feePercent',
  FEE_BASE_CHANNEL = 'feeBaseChannel'
}
